import { useEffect, useState } from 'react';
import { db } from 'src/config/firebase';
import { useParams } from 'react-router-dom';
import { useCompanyData } from '../contexts/DataContext';
const useCategoryList = () => {
  const { data } = useCompanyData();
  const [services, setServices] = useState([]);
  const [courses, setCourses] = useState([]);
  const [categoryName, setCategoryName] = useState('');
  const [description, setDescription] = useState('');
  const [categoryCover, setCategoryCover] = useState('');
  const { categoryId } = useParams();

  useEffect(() => {
    const fetchSerivces = async (categoryId) => {
        let array = [];
        let serviceResponse = await (await db.ref(`Services/`).orderByChild('serviceCategoryId').equalTo(categoryId).once('value')).val();
        if(serviceResponse) {
          Object.values(serviceResponse).forEach(v => {
            if(v.enabled && v.approved && !v.archive && !v.courses) array.push(v);
          })
        };
        setServices(array)
    };

    const fetchCourses = async (categoryId) => {
      let array = [];
      let serviceResponse = await (await db.ref(`Courses/`).orderByChild('courseCategoryId').equalTo(categoryId).once('value')).val();
      if(serviceResponse) {
        Object.values(serviceResponse).forEach(v => {
          array.push(v);
        })
      };
      setCourses(array)
  };

    const fetchCategoryName = async (categoryId) => {
        let categoryName = await (await db.ref(`PartnerCategories/${categoryId}/name`).once('value')).val();    
        setCategoryName(categoryName)
    };

    const fetchCategoryDescription = async (categoryId) => {
      let description = await (await db.ref(`PartnerCategories/${categoryId}/description`).once('value')).val();    
      setDescription(description)
  };

    const fetchCategoryCover = async (categoryId) => {
      let categoryCover = await (await db.ref(`PartnerCategories/${categoryId}/photo`).once('value')).val();    
      setCategoryCover(categoryCover)
    };

    fetchSerivces(categoryId);
    fetchCourses(categoryId);
    fetchCategoryName(categoryId);
    fetchCategoryCover(categoryId);
    fetchCategoryDescription(categoryId)
  }, [categoryId]);

  return { services, courses, categoryName, categoryCover, description };
};

export default useCategoryList;